function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gm_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M0-48h640v480H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt",
  clipPath: "url(#gm_svg__a)",
  transform: "translate(0 48)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M0-128h640V85.3H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 85.3h640V121H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009",
  d: "M0 120.9h640V263H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 263.1h640v35.6H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#090",
  d: "M0 298.7h640V512H0z"
}));

var SvgGm = function SvgGm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgGm;